import { Outlet, useNavigate } from "react-router";
import { XIcon } from "lucide-react";
export function Header() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 bg-transparent backdrop-blur-md border-b shadow-sm z-10">
      <div className="px-4 sm:px-24 py-4 flex justify-between items-center">
        <h1 className="text-xl font-semibold text-black pl-2 sm:pl-8">Legal</h1>
        <button className=" text-black" onClick={() => navigate(-1)}>
          <XIcon className="w-6 h-6" />
        </button>
      </div>
    </header>
  );
}

export default function LegalLayout() {
  return (
    <div className="flex flex-col h-screen">
      <Header />
      <div className="flex-1 pt-8">
        <Outlet />
      </div>
    </div>
  );
}
